<template>
  <div class="flex my-4">
    <div class="status-field flex items-center h-100 mt-1">
      <div
        class="status cursor-pointer"
        :class="params.data.status"
        @click="ChangeStatus"
      ></div>
    </div>
    <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <edit-icon
        size="1.3x"
        @click="$router.push({ name: 'Company_admin_user_edit',params: { id: params.data } })"
        class="hover:text-primary cursor-pointer"
      />
      <trash-2-icon
        size="1.3x"
        class="ml-3 hover:text-primary cursor-pointer"
        @click="ConfirmDelete"
      />
    </div>
  </div>
</template>

<script>
import { EditIcon, Trash2Icon } from 'vue-feather-icons'

export default {
  name: 'CellRendererActions',
  components: {
    EditIcon,
    Trash2Icon
  },
  methods: {
    ChangeStatus () {
      const payload = {
        id: this.params.data.user_id,
        data: { is_active: this.params.data.status !== "active" }
      }

      this.$vs.loading()
      this.$store.dispatch('user/UserEdit', payload)
        .then(res => {
          if (res.success) {
            this.params.data.refreshData()
            this.ShowSuccessMessage({ title: 'Success', text: 'User status has been changed' })
          }
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => this.$vs.loading.close())
    },
    ConfirmDelete () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: 'You will not be able to recover this User!',
        accept: this.Delete,
        acceptText: 'Delete'
      })
    },
    Delete () {
      this.$store.dispatch("user/Delete", this.params.data.user_id)
        .then(() => {
          this.params.data.refreshData()
          this.ShowSuccessMessage({
            title: 'User Deleted',
            text: 'The selected User was successfully deleted'
          })
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    }
  }
}
</script>

